export default "__VITE_ASSET__BvoWL_nA__"